'use strict';

angular.module('TurneroApp').component('coGruposUsuarios', {
    bindings: {
        centroAtencionSeleccionado: '<'
    },
    controller: [
        'grupoUsuarioService',
        'utilsService',
        'TurneroAppConstant',
        function (grupoUsuarioService, utilsService, TurneroAppConstant) {
            var ctrl = this;

            ctrl.grupoCrear = false;
            ctrl.grupoModificar = false;
            ctrl.grupoConsultar = true;
            ctrl.grupoVer = false;
            ctrl.grupos = {};
            ctrl.focusBuscar = false;
            ctrl.permisos = TurneroAppConstant.Permisos;
            ctrl.filter = false;

            ctrl.limitOptions = [10, 25, 50, 75, 100, {
                label: 'Todos',
                value: function () {
                    return ctrl.pagination.total;
                }
            }];

            ctrl.query = {
                limit: 10,
                page: 1,
                filter: ''
            };

            //Se inicializa en null para que al principio no tome que no hay valores
            ctrl.pagination = {
                total: null
            };

            ctrl.limpiarMemoria = function () {
                ctrl.grupos = {};
                ctrl.grupoCrear = false;
                ctrl.grupoModificar = false;
                ctrl.grupoConsultar = false;
                ctrl.grupoVer = false;
            }

            ctrl.mostrarBuscar = function () {
                ctrl.filter = true;
                ctrl.focusBuscar = true;
            };

            ctrl.$onChanges = function () {
                ctrl.centroAtencionSeleccionado.id && ctrl.grillaReload();
            };

            ctrl.removeFilter = function () {
                ctrl.query.filter = '';
                ctrl.grillaReload();
                ctrl.filter = false;
            };

            ctrl.grillaReload = function () {
                ctrl.limpiarMemoria();
                ctrl.grupoConsultar = true;
                if (ctrl.query.filter.length > 2 || ctrl.query.filter.length == 0) {
                    ctrl.getData(ctrl.query.page, ctrl.query.limit, 'grid', cargarDatos)
                }
            };

            ctrl.getData = function (page, limit, tipo, callback) {

                grupoUsuarioService.getfiltro({
                    'filtro.id_Centro_Atencion': ctrl.centroAtencionSeleccionado.id,
                    'filtro.nro_Pagina': page,
                    'filtro.tam_Pagina': limit,
                    'filtro.texto': ctrl.query.filter
                }).$promise.then(function (data) {
                    callback(tipo, data);
                }).catch(function (req) {
                    utilsService.errores(req);
                });

            }

            function cargarDatos(tipo, data) {
                if (tipo == 'grid') {
                    ctrl.grupos = data.Data;
                    ctrl.pagination.total = data.Paging.Reg_Totales;
                } else if (tipo == 'xls') {
                    var arrayObjeto = data.Data;
                    ctrl.arrayExport = [];
                    ctrl.arrayExport[0] = [ctrl.centroAtencionSeleccionado.id, ctrl.centroAtencionSeleccionado.text];
                    ctrl.arrayExport[1] = ['Id', 'Nombre', 'Usuarios'];
                    for (var i = 0; i < arrayObjeto.length; i++) {
                        ctrl.arrayExport[i + 2] = [
                            arrayObjeto[i].Id_Grupo_Usuario,
                            arrayObjeto[i].N_Grupo_Usuario,
                            arrayObjeto[i].Cantidad_Usuarios
                        ]
                    }
                    swal.close();
                    ctrl.Excel.down([{
                        name: 'Grupos-Usuarios',
                        data: ctrl.arrayExport
                    }]);
                }
            }

            ctrl.crearGrupo = function () {
                ctrl.limpiarMemoria();
                ctrl.grupoCrear = true;
                ctrl.tLoadAlta();
            };

            ctrl.modificarGrupo = function (item) {
                ctrl.limpiarMemoria();
                ctrl.grupoModificar = true;
                ctrl.tLoadModificar(item);
            };

            ctrl.verGrupo = function (item) {
                ctrl.limpiarMemoria();
                ctrl.grupoVer = true;
                ctrl.tLoadModificar(item);
            };

            ctrl.eliminarGrupo = function (item) {
                swal({
                    title: "Eliminar Grupo",
                    text: "¿Desea quitar el grupo del centro de atención?",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#e77a1e",
                    confirmButtonText: "Si, eliminarlo!",
                    cancelButtonText: "No, cancelar!",
                }).then(function () {
                    grupoUsuarioService.delete({ 'id': item.Id_Grupo_Usuario }).$promise.then(function (res) {
                        ctrl.grillaReload();
                        swal("Eliminado!", "El grupo ha sido eliminado del centro correctamente.", "success");
                    }).catch(function (req) {
                        utilsService.errores(req);
                    });
                });
            };

            //EXPORTAR A EXCEL
            ctrl.isOpen = false;
            ctrl.selectedMode = 'md-fling';
            ctrl.selectedDirection = 'up';
            ctrl.exportar = function (tipo, arrayObjeto) {
                ctrl.arrayExport = [];
                ctrl.getData(1, ctrl.pagination.total, tipo, cargarDatos);
            }
            ctrl.Excel = {
                down: function () {
                },
            }
        }
    ],
    template: require('./grupoUsuarios.html')
});


// WEBPACK FOOTER //
// ./app/components/grupos/grupos-usuarios/grupoUsuariosComponent.js